import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Textarea, InputDate, TimePicker } from 'components/fields'
import { ImagePicker } from 'containers/misc'

export default class LogForm extends Component {
  static propTypes = {
    prefix: PropTypes.any,
    storeRemoved: PropTypes.bool
  }

  static defaultProps = {
    prefix: null,
    storeRemoved: false
  }

  render() {
    const { storeRemoved } = this.props
    const prefix = this.props.prefix && this.props.prefix.length > 0
      ? `${this.props.prefix}.`
      : ''

    return (
      <div>
        <div className="row">
          <div className="col-xs-12">
            <Textarea
              name={`${prefix}description`}
              label="Description of your progress"
              intlKey="label.description_of_progress"
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <InputDate
              name={`${prefix}date`}
              label="Date"
              intlKey="label.date"
              maxToday
            />
          </div>

          <div className="col-xs-12 col-sm-6">
            <TimePicker
              name={`${prefix}duration`}
              label="Duration (mins)"
              intlKey="label.duration"
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <ImagePicker
              name={`${prefix}fileUrls`}
              storeRemoved={storeRemoved}
              isFile={false}
            />
          </div>
        </div>
      </div>
    )
  }
}
